
import HTTP from "./http.service";
import Storage from "./storage.service";

var Business = {};

Business.getBusinessConfig = () => {
	let config = {
		method: "get",
		url: "/biz_config/app",
		headers: {
			"virgin-api-version": "v1",
			"virgin-device-os": "web",
			"cache-control": "no-cache",
		},
	};

	HTTP(config)
		.then((response) => {
			let businessConfigObj = response.data;

			businessConfigObj["vat_factor"] =
				1 + businessConfigObj["vat_percentage"] / 100;

			businessConfigObj["min_promo_code_length"] = parseInt(
				businessConfigObj["min_promo_code_length"],
				10
			);
			businessConfigObj["max_promo_code_length"] = parseInt(
				businessConfigObj["max_promo_code_length"],
				10
			);

			Storage.setShared("businessConfig", businessConfigObj);
		})
		.catch((error) => {
			Storage.setShared("businessConfig", false);
		});
};

export default Business;